import { withParams } from 'vuelidate/lib';

const onlyLettersNumbers = withParams({ type: 'onlyLettersNumbers' }, value => {
  var str = value;
  var regex = new RegExp('^[a-zA-Z0-9/]*$');
  return regex.test(str);
});

export { onlyLettersNumbers };
